export default "__VITE_ASSET__2a17ecea__"